function setCookie(cname, cvalue, exdays) {
  const d = new Date();
  d.setTime(d.getTime() + exdays * 24 * 60 * 60 * 1000);
  let expires = "expires=" + d.toUTCString();
  document.cookie = cname + "=" + cvalue + ";" + expires + ";path=/";
}
function getCookie(cname) {
  let name = cname + "=";
  let decodedCookie = decodeURIComponent(document.cookie);
  let ca = decodedCookie.split(";");
  for (let i = 0; i < ca.length; i++) {
    let c = ca[i];
    while (c.charAt(0) == " ") {
      c = c.substring(1);
    }
    if (c.indexOf(name) == 0) {
      return c.substring(name.length, c.length);
    }
  }
  return "";
}

$(document).ready(function () {
  $("ul.footer-block__details-content.list-unstyled a").click(function (e) {
    var hrf = $(this).attr("href");
    if (hrf == "#size-guide") {
      setTimeout(function () {
        $("body").addClass("noscroll");
        $(".size-guide").fadeIn();
      }, 200);
      e.preventDefault();
    }
  });

  
  let sz = getCookie("sz");
  if (sz !== "") {
    $(
      ".product-form__input input[type=radio][name^=Size][value=" + sz + "]"
    ).click();
  }

  $(".product-form__input input[type=radio]").change(function () {
    if ($(this).hasClass("low-stock")) {
      $(".lowstock--grid").removeClass("hide");
    } else {
      $(".lowstock--grid").addClass("hide");
    }
  });

  $(document).on("click", "p.sizeshow", function (e) {
    setTimeout(function () {
      $("body").addClass("noscroll");
      $(".size-guide").fadeIn();
    }, 200);
    e.preventDefault();
  });

  $(".seee-sizeguide").click(function (e) {
    setTimeout(function () {
      $("body").addClass("noscroll");
      $("#" + $(e.target).data("sizechartid")).fadeIn();
    }, 200);
    e.preventDefault();
  });

  $(document).on("click", function (e) {
    if (
      $(e.target).closest("body.noscroll .int-size-cot .size-container")
        .length === 0
    ) {
      $(".size-guide").fadeOut();
      $("body").removeClass("noscroll");
    }
  });

  $(document).on("click", "span.checkSize",function (e) {
    setTimeout(function () {
      $("body").addClass("noscroll");
      let v = $(e.target).data("sizechartid");
      if (v == "sz_") {
        $(".size-guide").fadeIn();
      } else {
        $("#" + $(e.target).data("sizechartid")).fadeIn();
      }
    }, 200);
  });

  $(document).on("click", ".size-container .close-btn",function (e) {
    $(".size-guide").fadeOut();
    $("body").removeClass("noscroll");
  });
  
  $(".product__info-wrapper.grid__item .quantity__input[type=number]").keyup(
    function () {
      if ($(this).val().length === 0) {
        $("product-form.product-form").addClass("formEmpty");
      } else {
        $("product-form.product-form").removeClass("formEmpty");
      }
    }
  );

  if ($(".collection-hero").length) {
    if (window.location.href.indexOf("TRADI4929") > -1) {
      $("h1.collection-hero__title").html("TRADIZIONALE");
    }
    if (window.location.href.indexOf("TRADI4929B") > -1) {
      $("h1.collection-hero__title").html("TRADIZIONALE BICOLOR");
    }
  }
  $(document).on(
    "click",
    "span.boost-pfs-filter-option-swatch-image",
    function () {
      if ($(window).width() < 767) {
        setTimeout(function () {
          $(
            ".boost-pfs-filter-tree-mobile-style2 span.boost-pfs-filter-close"
          )[0].click();
        }, 1000);
      }

     /* if (1000 > $(window).width() && $(window).width() > 750) {
        if ($(window).width() > $(window).height())
          
          //this causes a problem with scrolling after swatch selection on mobile
          $("html, body").animate(
            {
              scrollTop: $("h1.collection-hero__title").offset().top,
            },
            800
          );
      }*/
    }
  );

  /* Newsletter Homepage */
  var live_url = window.location.href;
  if (live_url.indexOf("form_type=customer") > 0) {
    var custEmail = $(".newsletter-form__field-wrapper").find("input").val();
    if (custEmail) {
      var customerEmail = custEmail.length;
      if (customerEmail > 0) {
        $("#news-errors").show();
      } else {
        $("#news-errors").hide();
      }
    }
  }

  /* on pdp if there's a product specific size chart move to the body, it's a hack for the moment to fix a display problem */
  $(".size-guide[id^='sz']").each(function(e){
    $(this).prependTo(document.body);
  });
  
}); /* end on doc loaded */

$(document).on('click', ".product-form__input input[type=radio][name^=Size]", function(e) {
  //console.log($(this).val());
  setCookie("sz", $(this).val(), 30);
});


$(document).on("click", ".info-accordian-button", function (e) {
  $(this)
    .next(".info-accordian")
    .toggleClass("info-accordian-open info-accordian-closed");
  $(this).text($(this).text() == "READ MORE" ? "READ LESS" : "READ MORE");
  $(this).css('display','none');
});

$(document).on("click", ".close-accordian-button", function (e) {
  $(this)
    .parent(".info-accordian")
    .toggleClass("info-accordian-open info-accordian-closed");
  $(this)
    .parent(".info-accordian")
    .prev(".info-accordian-button")
    .text("READ MORE");
  $('.info-accordian-button').css('display','');
  window.scrollTo({top: 0, behavior: 'smooth'});
});
